"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectRealtorFiltersWidget = void 0;
var React = _interopRequireWildcard(require("react"));
var _valuationUtilsComponent = require("@cian/valuation-utils-component");
var _FilterWithDropdownList = require("../../components/packages/FilterWithDropdownList");
var _SelectRealtorFiltersLayout = require("../../components/SelectRealtorFiltersLayout");
var _useFiltersForm = require("./utils/useFiltersForm");
var _widgetContext = require("../../context/widgetContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable  @typescript-eslint/no-explicit-any */

const SelectRealtorFiltersWidget = props => {
  const {
    onChange,
    initialState,
    stateRef,
    targetPage
  } = props;
  const isDesktop = (0, _valuationUtilsComponent.useIsDesktop)();
  const {
    state,
    setDealType,
    setOfferType,
    setObjectType,
    objectTypeOptions,
    dealTypeSelectorOptions,
    offerTypeSelectorOptions
  } = (0, _useFiltersForm.useFiltersForm)({
    onChange,
    initialState,
    stateRef
  });
  return /*#__PURE__*/React.createElement(_widgetContext.Provider, {
    value: {
      targetPage,
      isDesktop
    }
  }, /*#__PURE__*/React.createElement(_SelectRealtorFiltersLayout.SelectRealtorFiltersLayout, {
    dealTypeFilter: /*#__PURE__*/React.createElement(_FilterWithDropdownList.FilterWithDropdownList, {
      values: dealTypeSelectorOptions,
      value: state.dealType,
      onValueChange: setDealType,
      placeholder: "\u0422\u0438\u043F \u0441\u0434\u0435\u043B\u043A\u0438",
      testId: "dealType_filter",
      isFirstFilter: true
    }),
    offerTypeFilter: /*#__PURE__*/React.createElement(_FilterWithDropdownList.FilterWithDropdownList, {
      values: offerTypeSelectorOptions,
      value: state.offerType,
      onValueChange: setOfferType,
      placeholder: "\u0422\u0438\u043F \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438",
      testId: "offerType_filter"
    }),
    objectTypeFilter: /*#__PURE__*/React.createElement(_FilterWithDropdownList.FilterWithDropdownList, {
      values: objectTypeOptions,
      value: state.objectType,
      onValueChange: setObjectType,
      placeholder: "\u041E\u0431\u044A\u0435\u043A\u0442",
      testId: "objectType_filter",
      isLastFilter: true
    })
  }));
};
exports.SelectRealtorFiltersWidget = SelectRealtorFiltersWidget;
SelectRealtorFiltersWidget.displayName = 'SelectRealtorFiltersWidget';